import React from 'react';

import { Input } from './styles';

interface CheckboxProps {
  children: React.ReactNode;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function Checkbox({ children, checked, onChange }: CheckboxProps) {
  return (
    <label>
      <Input type="checkbox" checked={checked} onChange={onChange} />
      {children}
    </label>
  );
}
